/**
 * @class LinearListObject
 */
export default class LinearListObject {
    /**
     * @param {Number}  id
     * @param {String}  key
     * @param {Number}  index
     * @param {String}  displayName
     */
    constructor(id, key, index, displayName) {
        this._id = id;
        this._key = key;
        this._index = index;
        this._displayName = displayName;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - LinearProduct");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @return {String}
     */
    get key() {
        return this._key;
    }

    /**
     * @return {Number}
     */
    get index() {
        return this._index;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @return {Boolean}
     */
    isItem = () => {
        return false;
    };
}
